module.exports = __webpack_public_path__ + "static/Grafika2@2x-11b640c64bbf172ef9602f69660ee535.png";